import { FilterList } from '@mui/icons-material';
import { Button, Collapse } from '@mui/material';
import { ReactNode, useState } from 'react';
import { useBreakpoints } from '../../hooks/useBreakpoints';

interface CollapsibleFiltersProps {
  children: ReactNode;
}

const styles = {
  quickFiltersButton: {
    mb: 1,
    mr: 'auto',
    transition: 'all 0.5s ease',
    justifySelf: 'flex-start',
    pl: { xs: 0.5 },
  },
  quickFiltersCollapse: {
    width: '100%',
    '& .MuiCollapse-wrapperInner': {
      display: 'flex',
      flexDirection: 'column',
      pt: 0.5,
      gap: 2,
    },
  },
};

const CollapsibleFilters = ({ children }: CollapsibleFiltersProps) => {
  const { isMobile } = useBreakpoints();
  const [showQuickFilters, setShowQuickFilters] = useState(false);

  if (!isMobile) {
    return children;
  }

  return (
    <>
      <Button
        variant='text'
        sx={{
          ...styles.quickFiltersButton,
          ...(!showQuickFilters && {
            mb: -1,
          }),
        }}
        endIcon={<FilterList />}
        onClick={() => setShowQuickFilters(!showQuickFilters)}
      >
        Quick Filters
      </Button>
      <Collapse in={showQuickFilters} sx={styles.quickFiltersCollapse}>
        {children}
      </Collapse>
    </>
  );
};

export default CollapsibleFilters;
